import React, { useEffect, useState } from 'react';
import styles from '../styles/pages/aboutuspage.module.css';
import SimpleCard from '../components/SimpleCard_extraText';
import ModalImage from '../components/ModalImage';
import axios from 'axios';
import logo from '../assets/images/logo.png';
import { useAuth } from "../authentication/AuthContext";

function BoardOfDirectors() {
  const [images, setImages] = useState([]);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Fetch images on initial load
    fetchImages();
  }, []);

  const fetchImages = () => {
    axios.get("/api/images")
      .then((response) => {
        const data = response.data.map((img) => ({
          id: img._id,
          _id: img._id,
          name: img.name,
          designation: img.designation,
          img: `/api/images/${img._id}`,
        }));
        setImages(data);
      })
      .catch((err) => console.error("Error fetching images:", err));
  };

  const handleImagesSubmit = () => {
    // Call fetchImages to get updated images
    fetchImages();
  };

  const Extra = () => <img className={styles.logo_bg_side} src={logo} alt="Logo" />;
  const Filler = () => <span style={{ display: "none" }}></span>;

  return (
    <div className="body">
      <div className="heading">BOARD OF DIRECTORS</div>
      <hr />
      <hr />
      <div className="body">
        {isAuthenticated && (
          <ModalImage
            value={images}
            label="image"
            onSubmit={handleImagesSubmit}  // Ensure onSubmit refreshes data
          />
        )}

        {/* Sections for different designations */}
        <div className={styles.sectionsContainer}>
          <div className={styles.directors}>
            <SimpleCard
              list={images.filter((img) => img.designation === "FOUNDER")}
              extra={Extra}
            />
          </div>

          <div className={styles.directors}>
            <SimpleCard
              list={images.filter((img) => img.designation === "PRESIDENT" || img.designation === "VICE PRESIDENT")}
              extra={Filler}
            />
          </div>

          <div className={styles.directors}>
            <SimpleCard
              list={images.filter((img) => img.designation === "DIRECTOR")}
              extra={Filler}
            />
          </div>

          <div className={styles.directors}>
            <SimpleCard
              list={images.filter((img) => img.designation === "PROF. DIRECTOR")}
              extra={Filler}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BoardOfDirectors;
